import { createFileRoute, useSearch } from "@tanstack/react-router";

import { PageHeader } from "@/components/layout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { RevPilotComparisonForm } from "@/features/rev-pilot/rev-pilot-comparison-form";
import { useAppNavigate } from "@/lib/use-app-navigate";
import type { Id } from "@constructionautomation/backend/convex/_generated/dataModel";

function parseTakeoffJobId(value: unknown): Id<"takeoffPilotJobs"> | undefined {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  return /^[a-z0-9]+$/i.test(trimmed) ? (trimmed as Id<"takeoffPilotJobs">) : undefined;
}

export const Route = createFileRoute("/revPilot/new")({
  component: NewRevPilotPage,
});

export function NewRevPilotPage() {
  const navigate = useAppNavigate();
  const search = useSearch({ strict: false }) as { sourceTakeoffJobId?: string };
  const initialV1TakeoffJobId = parseTakeoffJobId(search.sourceTakeoffJobId);

  return (
    <div className="space-y-6">
      <PageHeader
        title="RevPilot"
        description="Create schedule or plan-set revision comparisons from uploaded PDFs or project document revisions"
      />

      <Card className="max-w-4xl">
        <CardHeader>
          <CardTitle>Create Revision Comparison</CardTitle>
          <CardDescription>
            Compare two revisions and generate export artifacts for review.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <RevPilotComparisonForm
            cancelTo="/revPilot"
            initialV1TakeoffJobId={initialV1TakeoffJobId}
            onSuccess={(comparisonId) => {
              navigate({
                to: "/revPilot/$comparisonId",
                params: { comparisonId },
                title: "Comparison",
              });
            }}
          />
        </CardContent>
      </Card>
    </div>
  );
}
